import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthTabsComponent } from '../components/auth-tabs/auth-tabs.component';
import { LoginComponent } from '../components/login/login.component';
import { EsqueceuSenhaComponent } from '../components/esqueceu-senha/esqueceu-senha.component';
import { AlterarSenhaComponent } from '../components/alterar-senha/alterar-senha.component';

const routes: Routes = [
  {
    path: '',
    component: AuthTabsComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'esqueceu-senha',
    component: EsqueceuSenhaComponent
  },
  {
    path: 'alterar-senha/:token',
    component: AlterarSenhaComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
